import { render } from "./About-us.vue?vue&type=template&id=fff11668&scoped=true"
import script from "./About-us.vue?vue&type=script&lang=js"
export * from "./About-us.vue?vue&type=script&lang=js"

import "./About-us.vue?vue&type=style&index=0&id=fff11668&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff11668"]])

export default __exports__